export const TIME_PERIODS = {
  LAST_4_WEEKS: 'last_4_weeks',
  LAST_12_WEEKS: 'last_12_weeks',
  ALL_TIME: 'all_time',
  CUSTOM: 'custom'
};

export const TIME_PERIOD_OPTIONS = [
  {id: TIME_PERIODS.LAST_4_WEEKS, label: 'Last 4 weeks'},
  {id: TIME_PERIODS.LAST_12_WEEKS, label: 'Last 12 weeks'},
  {id: TIME_PERIODS.ALL_TIME, label: 'All Period'},
  {id: TIME_PERIODS.CUSTOM, label: 'Custom'}
];

export const DEFAULT_TIME_PERIOD = TIME_PERIODS.LAST_12_WEEKS;

export const SEGMENTS = {
  ALL: 'all',
  NEW: 'newCustomers',
  OCCASIONAL: 'occasionalCustomers',
  FREQUENT: 'frequentCustomers'
};

export const SEGMENT_DEFINITIONS = {
  totalCustomers: {
    label: 'Total',
    tooltip:
      'All unique customers who placed at least one order in the selected time period.'
  },
  newCustomers: {
    label: 'New',
    tooltip:
      'Customers who placed their first-ever order during the selected time period.'
  },
  occasionalCustomers: {
    label: 'Occasional',
    tooltip: 'Customers who placed 2–4 orders during the selected time period.'
  },
  frequentCustomers: {
    label: 'Frequent',
    tooltip:
      'Customers who placed 5 or more orders during the selected time period.'
  }
};

export const LOCATIONS_MAP_MIN_CUSTOMERS = 2;

export const TOP_CUSTOMERS_LIMIT = 5;
